const Login = () => import('@/views/Login.vue');
const AuthPage = () => import('@/views/AuthPage.vue');
const AdminLogin = () => import('@/views/login/index');
import Main from '@/components/main/Main';
// const Register = () => import('@/views/Register.vue')

export default [
  {
    path: '/emc/login', // 为了转发nginx，避免重名，故而加一个index地址TODO 改进
    name: 'loginPage',
    component: Login,
    meta: {
      showInMenu: false
    }
  },
  {
    name: '_home',
    path: '/home',
    component: Main,
    redirect: '/home/index',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '首页',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'home',
        path: '/home/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/home'),
        meta: {
          showInMenu: true,
          path: '/home',
          title: '系统首页',
          icon: 'logo-apple'
        }
      },
      {
        name: 'product',
        path: '/product/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/product'),
        meta: {
          showInMenu: true,
          path: '/product',
          title: '核心产品',
          icon: 'logo-apple'
        }
      },
      {
        name: 'solution',
        path: '/solution/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/solution'),
        meta: {
          showInMenu: true,
          path: '/solution',
          title: '解决方案',
          icon: 'logo-apple'
        }
      },
      {
        name: 'about',
        path: '/about/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/about'),
        meta: {
          showInMenu: true,
          path: '/about',
          title: '关于我们',
          icon: 'logo-apple'
        }
      },
      {
        name: 'news',
        path: '/news/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/news'),
        meta: {
          showInMenu: true,
          path: '/news',
          title: '行业新闻',
          icon: 'logo-apple'
        }
      },
      {
        name: 'technology',
        path: '/technology/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/technology'),
        meta: {
          showInMenu: true,
          path: '/technology',
          title: '信息技术',
          icon: 'logo-apple'
        }
      },
      {
        name: 'resources',
        path: '/resources/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/resources'),
        meta: {
          showInMenu: true,
          path: '/resources',
          title: '人力资源',
          icon: 'logo-apple'
        }
      },
      {
        name: 'newsDetail',
        path: '/newsDetail/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/newsDetail'),
        meta: {
          showInMenu: true,
          path: '/newsDetail',
          title: '新闻详情',
          icon: 'logo-apple'
        }
      }
    ]
  },
  {
    path: '/adminLogin', // 为了转发nginx，避免重名，故而加一个index地址TODO 改进
    name: 'adminLogin',
    component: AdminLogin,
    meta: {
      showInMenu: false
    }
  },
  {
    path: '/authPage', // 为了转发nginx，避免重名，故而加一个index地址TODO 改进
    name: 'authPage',
    component: AuthPage,
    meta: {
      showInMenu: false
    }
  },
  {
    name: 'errorPage',
    path: '/errorPage',
    component: () => import('@/views/errorPage'),
    meta: {
      showInMenu: false
    }
  }
  // }
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: Register
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  // }
];
